<app-header></app-header>
<app-navbar [selected]="'administration'"></app-navbar>

<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100 ">
        <!-- 
        04/04/2025 - Actualmente no se tiene contemplado crear nuevos roles, la funcionalidad está realizada.-->
        <div class="row mb-3">
            <div class="col-md-6 fw-bold">
                <label for="basic-url" class="form-label color-text"> {{ 'tariffRole.rol-acceso' | translate }} </label>
            </div>
            <!--          <div class="col-md-6 text-end">
                <button type="button" class="btn custombutton" (click)="checkRow()">{{ 'tariffRole.newRole' | translate
                    }}</button>
            </div>-->

        </div>

        @if (this.listRole.length !== 0) {
        <div class="row">
            <fieldset>
                <table class="table text-center" role="table" [attr.aria-label]="'tariffRole.rol-acceso' | translate">
                    <thead>
                        <tr>
                            <th scope="col">
                                <span class="visually-hidden">{{ 'seleccionarFila' | translate }}</span>
                            </th>
                            <th scope="col">{{ 'tariffRole.codigo' | translate }}</th>
                            <th scope="col">{{ 'tariffRole.masterRol' | translate }}</th>
                            <th scope="col">{{ 'tariffRole.active' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (rol of listRole; track $index) {
                        <tr [ngClass]="{'resaltado': selectedRowId === rol.functionCode}">
                            <td role="cell">
                                <input type="radio" [id]="'radio-' + rol.functionCode" name="flexRadioDefault"
                                    [checked]="selectedRowId === rol.functionCode" (click)="checkRow(rol)">
                                <label [for]="'radio-' + rol.functionCode" class="visually-hidden">
                                    {{ "seleccionarFilaCon" | translate }}:
                                    {{ 'tariffRole.codigo' | translate }} {{ this.generateCodi(rol.functionCode) }},
                                    {{ 'tariffRole.masterRol' | translate }} {{ rol.meaning }},
                                    {{ 'tariffRole.active' | translate }} {{ rol.active ? ('model.active' | translate) :
                                    ('model.inactive' | translate) }}
                                </label>
                            </td>
                            <td role="cell">{{ this.generateCodi(rol.functionCode) }}</td>
                            <td role="cell">{{ rol.meaning }}</td>
                            <td role="cell">
                                @if(rol.active) {
                                <span>{{ 'model.active' | translate }}</span>
                                }@else{
                                <span>{{ 'model.inactive' | translate }}</span>
                                }
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </fieldset>

            @if(this.selectedRowId !== '' || this.creatingRole) {
            <div class="separator mt-5"></div>

            <div>
                <form [formGroup]="formRoleComponent" (ngSubmit)="createOrUpdateRole()">
                    <div class="mt-5">
                        @if(this.creatingRole){
                        <h2 class="textformat mb-4">{{ 'tariffRole.newRole' | translate }}
                        </h2>
                        }@else {
                        <h2 class="textformat mb-4">{{ 'tariffRole.updateRole' | translate
                            }}</h2>
                        }
                    </div>

                    <div class="row">
                        <!-- Name Role -->
                        <div class="col-md-3 mb-3">
                            <fieldset [attr.disabled]="this.updateRole ? true : null">
                                <label class="form-label" for="functionCode">{{ 'tariffRole.nameRole' | translate
                                    }}<span>
                                        *</span></label>
                                <input id="functionCode" name="functionCode" type="text" class="form-control"
                                    placeholder="Name Role" formControlName="functionCode"
                                    formControlName="functionCode"
                                    [class.input-error]="sharedService.controlInput(formRoleComponent,'functionCode')">
                                <app-message-input [form]="formRoleComponent"
                                    [field]="'functionCode'"></app-message-input>
                            </fieldset>
                        </div>

                        <!-- Description -->
                        <div class="col-md-3 mb-3">
                            <label class="form-label" for="meaning">{{ 'tariffRole.descripcion' | translate }}<span>
                                    *</span></label>
                            <input id="meaning" name="meaning" type="text" class="form-control" placeholder="Name Role"
                                formControlName="meaning"
                                [class.input-error]="sharedService.controlInput(formRoleComponent,'meaning')">
                            <app-message-input [form]="formRoleComponent" [field]="'meaning'"></app-message-input>
                        </div>

                        <!-- Active Role Checkbox -->
                        <div class="col-md-6 mb-3">
                            <input class="form-check-input mx-3" type="checkbox" id="active" name="active"
                                formControlName="active" checked>
                            <label class="form-check-label" for="active">
                                {{ 'tariffRole.active' | translate }}
                            </label>
                        </div>
                    </div>
                    @if(!this.updateRole){
                    <button type="submit" class="btn custombutton mt-3">{{ 'tariffRole.createRole' | translate
                        }}</button>
                    }@else {
                    <button type="submit" class="btn custombutton mt-3 mx-2">{{ 'tariffRole.updateRole' | translate
                        }}</button>
                    <a type="button" class="btn custombutton mt-3" (click)="deleteRole()">Delete Role</a>
                    }
                </form>
            </div>
            }
            <app-alert-component [isOk]="messageVisibility.isSuccessFirst" [isDanger]="messageVisibility.isErrorFirts"
                [message]="errorMessage"
                (close)="messageVisibility.isSuccessFirst = messageVisibility.isErrorFirts = false"></app-alert-component>
        </div>
        }@else if(!this.loadListing) {
        <div class="alert" role="alert" style="background-color: #73EDFF;">
            {{ 'tariffRole.noRoleApp' | translate }}
        </div>
        }
    </main>

</div>